export default __webpack_public_path__ + "static/media/map.d06d4ef0.svg";